import * as C from '../constants';
const initialState = {};
export default function HomeReducer(state = initialState, action) {
    switch (action.type) {
        case C.GET_IM_MESSAGE:
            return Object.assign(state, { imlaywerInfo: action.imlaywerInfo });
        case C.GET_NUM_NOTICE:
            return Object.assign(state, { numNotice: action.numNotice });
        default:
            return state;
    }
}
